import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { ExplicacaoCalc } from "@/lib/campoCalculado/operadores";

/**
 * Por que um registro tem aquele valor num campo calculado, via RPC `campo_calc_explicar`
 * (docs/specs/campo-calculado.md §5.4). A RPC recalcula na hora — `gravado` é o que está em
 * custom_data; se diferir de `valor`, o registro está esperando recálculo.
 *
 * Busca só quando `enabled` (ex.: popover aberto). Sem cache longo: a explicação tem que
 * refletir a fórmula e o registro de agora.
 */
export function useExplicacaoCampoCalculado(fieldId: string, recordId: string | undefined, enabled: boolean) {
  return useQuery({
    queryKey: ["campo-calc-explicar", fieldId, recordId],
    queryFn: async (): Promise<ExplicacaoCalc | null> => {
      const { data, error } = await supabase.rpc("campo_calc_explicar" as any, {
        p_field_id: fieldId,
        p_record_id: recordId,
      });
      if (error) throw error;
      return (data as ExplicacaoCalc | null) ?? null;
    },
    enabled: enabled && !!recordId,
    staleTime: 0,
  });
}
